const paymentModal = {
  'paymentModal.title': 'Billing Statement',
  'paymentModal.splitInvoice.title': 'Split',
  'paymentModal.inputLabel': 'Statement balance',
  'paymentModal.splitInvoice.inputLabel': '{bold} amount',
  'paymentModal.splitInvoice.inputLabel02': 'Down payment',
  'paymentModal.splitInvoice.subtitle':
    'Number of installments {value} remaining',
  'paymentModal.generatePayment': 'Download your statement',
  'paymentModal.payStatement': 'Pay Statement',
  'paymentModal.payStatement.successful': 'The statement was paid successfully',
  'paymentModal.splitInvoice': 'Pay in installments',
  'paymentModal.validUntil': 'Due date',
  'paymentModal.instructions':
    'Use the code number below to pay until the due date.',
  'paymentModal.emptyState': "There's no amount for payment.",
  'paymentModal.copied': 'Copied!',
  'paymentModal.copy': 'Copy code number',
  'paymentModal.sendBySMS': 'Send SMS',
  'paymentModal.sentBySMS': 'SMS sent!',
  'paymentModal.sendByEmail': 'Send email',
  'paymentModal.sentByEmail': 'Email sent!',
  'paymentModal.lowerThanMinimumDisclaimer':
    'Your payment will remain overdue until the minimum amount is received.',
  'paymentModal.errorState':
    "Something went wrong and we couldn't fetch payment data.",
  'paymentModal.confirm': 'Confirm',
  'paymentModal.advance': 'Next',
  'paymentModal.closedValue': 'Total',
  'paymentModal.splitInvoice.rates': 'Fee',
  'paymentModal.splitInvoice.total': 'Total',
  'paymentModal.splitInvoice.tax': 'Tax',
  'paymentModal.splitInvoice.upfront': 'Down payment',
  'paymentModal.splitInvoice.totalRemaining': 'Total remaining',
  'paymentModal.splitInvoice.lastDateInfo': 'Last installment due date',
  'paymentModal.splitInvoice.outcomeTitle':
    'Invoice installment request completed.',
  'paymentModal.splitInvoice.outcomeSubtitle':
    'To confirm this contract, down payment must be done until due date. Use the code number below to pay.',
  'paymentModal.splitInvoice.noInstallmentOptions':
    'No split options available',
  'paymentModal.error.biggerValue':
    'Amount entered is greater than the total balance due.\nPlease enter a different amount.',
  'paymentModal.payment.agreement': 'Payment agreement',
  'paymentModal.payment.entrance': 'Down payment amount',
  'paymentModal.payment.entrance.date': 'Down payment due date',
  'paymentModal.agreement.contemplated': 'Statements',
  'paymentModal.agreement.interests.discount': 'Discount',
  'paymentModal.payment.installments': 'Installments ',
  'paymentModal.payment.installments.last': 'Last installment due date: ',
  'paymentModal.payment.installments.summary.title': 'Check the summary',
  'paymentModal.payment.installments.summary.entranceDate':
    'Down payment due date: {date}',
  'paymentModal.payment.installments.summary.dates': 'Installments due date',
  'paymentModal.payment.installments.summary.entranceValue':
    'Down payment amount: {value}',
  'paymentModal.payment.installments.summary.values': 'Summary',
  'paymentModal.payment.installments.summary.totalValue': 'Installment amount',
  'paymentModal.payment.installments.summary.interest':
    'Interests ({tax}% monthly)',
  'paymentModal.payment.installments.summary.taxes': 'Fee',
  'paymentModal.payment.installments.summary.totalInInstallments':
    'Total installment amount',
  'paymentModal.payment.installments.summary.final':
    'Installments {payments} {value}',
  'paymentModal.payment.installments.summary.legalTextCet':
    'Fees: {cet_month}% monthly and of {cet_anual}% anually',
  'paymentModal.payment.installments.summary.legalTextInterests':
    'Interest: {interests_month}% monthly and {interests_anual}% anually',
  'paymentModal.payment.installments.summary.legalTextDaily':
    'Tax: {rate_daily}% + {iof_daily}% daily rate',
  'paymentModal.payment.installments.error':
    'Something went wrong, please try again',
  'paymentModal.payment.installments.sucess': 'Agreement sucessfully generated',
  'paymentModal.payment.installments.errorDueDates':
    'There ate no date available for and agreement.',
  'paymentModal.warningBankslip':
    'Remember: failure to pay the total by the due date implies bank charges.',
  'paymentModal.invoice.agreement':
    'By clicking "Confirm" the agreement will be concluded, both physical and virtual cards will be blocked for use.',
  'paymentModal.invoice.agreementWaringBanksLip':
    'Inform the customer that the installment (agreement) will be made after the payment of this bill',
};

export default paymentModal;
